import { render, staticRenderFns } from "./modelZT.vue?vue&type=template&id=27d9f84e&scoped=true"
import script from "./modelZT.vue?vue&type=script&lang=js"
export * from "./modelZT.vue?vue&type=script&lang=js"
import style0 from "./modelZT.vue?vue&type=style&index=0&id=27d9f84e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d9f84e",
  null
  
)

export default component.exports